const HOTEL_REFUND_ERROR_MAP = {
  ORDER_IS_NOT_PAID: '訂單尚未付款，無法退款',
  HOTEL_ORDER_HAS_ALREADY_BEEN_REFUNDED: '此住宿訂單已退款，無法重複退款',
  REFUND_AMOUNT_EXCEEDS_BACK_BALANCE: '退款金額超過可退餘額',
}

export function mapHotelRefundErrorMessage(status) {
  const key = String(status || '').trim()
  return HOTEL_REFUND_ERROR_MAP[key] || '退款失敗，請稍後再嘗試一次'
}
